import { Outlet } from 'react-router-dom';
import AnalyticsLayout from '@/app/(dashboard)/analytics/layout';
export function AnalyticsLayoutWrapper() {
  return (
    <AnalyticsLayout>
      <Outlet />
    </AnalyticsLayout>
  );
}
